'use client';

import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { DOWNLOAD_APP_CTA, AppLandingPageAppLink } from '../../constants';
import caregiver from '../../assets/images/caregiver-avatar.png';
import { canUseWindow } from '../../wag-react/common/xenv';
import { getMobileDeviceSpec } from '../../wag-react/components/app-install-banner/utils/getMobileDeviceSpec';
import { TooltipBouncer, TooltipBouncerProps } from '../../wag-react/components/floating-action-buttons/components/TooltipBouncer';
export type DownloadAppBouncerProps = Omit<TooltipBouncerProps, 'avatar' | 'tooltip'> & {
  href?: string;
};
export const DownloadAppBouncer = ({
  href = DOWNLOAD_APP_CTA,
  ...rest
}: DownloadAppBouncerProps) => {
  const goToDownloadApp = () => {
    if (!href) {
      return;
    }
    const mobileDeviceSpec = getMobileDeviceSpec();
    const downloadUrl = mobileDeviceSpec?.isIOS ? AppLandingPageAppLink.AppStore : AppLandingPageAppLink.PlayStore;
    if (canUseWindow) {
      window.open(downloadUrl, '_blank');
    }
  };
  return <TooltipBouncer as="aside" avatar={{
    src: caregiver,
    alt: 'Wag! Caregiver'
  }} tooltip={{
    text: <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      width: '100%',
      fontWeight: 'normal'
    }}>
            Get the app
            <ChevronRightIcon className="w-4 h-4 ml-2 text-white" strokeWidth={2} />
          </div>,
    showArrow: false
  }} display={['flex', 'none', null]} onClick={goToDownloadApp} {...rest} data-sentry-element="TooltipBouncer" data-sentry-component="DownloadAppBouncer" data-sentry-source-file="index.tsx" />;
};